<template>
  <div  v-show="isVisibleProp">
    <span class="heading">Investment Header Information</span>
     <v-container>
      <v-row>
      <v-col col="3">
        <GetMaxInvestmentNumber id="glGetMaxInvestmentNumber"
          class="gl-trans-item-max-investment-no"
          v-model.number="editedItem.investmentId"
          :isNewItem="isNewItem"
          fieldType="Investment ID"
          :rules="reqdSelectValidation"
          :disabled="editedItem.isClosed"
        />
       </v-col>
       <v-col col="3">
        <ClarionDateControl id="investmentPurchaseDate"
          class="invest-trans-item-purchaseDate-date"
          :isIsoDate="false"
          label="Purchase Date"
          v-model="editedItem.purchaseDate"
          :rules="reqdSelectValidation"
          :isToggle="false"
          :isDisabled="editedItem.isClosed"
        />
      </v-col>
       <v-col cols="4">
          <v-autocomplete
            v-model="editedItem.fund"
            id="glDailyTransItemFundSelect"
            class="gl-daily-trans-item-fund-select"
            label="GL Fund"
            :items="funds"
            item-text="fundDesc"
            item-value="_id"
            ref="isFundRef"
          :disabled="editedItem.isClosed"

          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
      <v-col>
        <v-select id="invest-type"
          v-model="editedItem.type"
          :items="investmentTypeEnums"
          item-text="description"
          item-value="name"
          label="Type"
          :rules="reqdSelectValidation"
          :disabled="editedItem.isClosed"

          >
        </v-select>
      </v-col>
      <v-col col="3">
        <ClarionDateControl id="MaturityDate"
          class="invest-trans-item-Maturity-date"
          :isIsoDate="false"
          label="Maturity Date"
          v-model="editedItem.maturityDate"
          :isToggle="false"
          :isDisabled="editedItem.isClosed"

          />
        </v-col>
        <v-col>
           <v-autocomplete
            v-model="editedItem.groupCode"
            :items="collateralBanks"
            id="collateralBankTransItemBankNameText"
            class="collateral-bank-trans-item-bank-name-text"
            label="Group Code"
            item-text="bankName"
            item-value="bankIntials"
          :disabled="editedItem.isClosed"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
      <v-col>
        <v-text-field id="Investment#"
          class="Investment-trans"
          label="Investment #"
          v-model="editedItem.investmentNumber"
          :rules="reqdSelectValidation"
          @keydown="checkAlphaNumeric($event)"
          :disabled="editedItem.isClosed"
        ></v-text-field>
      </v-col>
      <v-col col="2">
        <v-text-field id="InterestRate#"
          class="Interest-Rate"
          label="Interest Rate %"
          v-model="editedItem.interestRate"
          type="number"
          :disabled="editedItem.isClosed"
        ></v-text-field>
      </v-col>
      <v-col>
          <v-autocomplete
            v-model="editedItem.bank"
            :items="banks"
            id="glDailyTransItemBankSelect"
            class="gl-daily-trans-item-bank-select"
            label="GL Bank"
            item-text="bankName"
            item-value="_id"
            ref="isBankRef"
          :disabled="editedItem.isClosed"
          ></v-autocomplete>
      </v-col>
    </v-row>
    </v-container>
     <v-row>
      <v-col col="2">
        <v-checkbox
          id="sharedBankEditItemIsReconAcct"
          class="ma-0 pa-0 ml-10 d-inline-flex"
          label="Closed"
          v-model="editedItem.isClosed"
        ></v-checkbox>
      </v-col>
      <v-col col="2">
        <v-checkbox
          class="ma-0 pa-0 ml-10 d-inline-flex"
          label="Hidden"
          v-model="editedItem.isHidden"
        ></v-checkbox>
      </v-col>
      <v-col col="2" class="heading">
        Investment Details
        <v-btn color="primary" small rounded class="ml-10" @click="openDialog"
        :disabled="editedItem.isClosed"
        >
        Add Detail
      </v-btn>
      <v-btn color="primary" small rounded class="ml-6"   @click="proceedToCreateMisc()"
      :disabled="!isCheckSelectedItem || isNewItem"
      >
        Create Misc Receipt
      </v-btn>
      <v-btn color="primary" small rounded class="ml-4" @click="deleteItems"
        :disabled="(selectedItems || []).length === 0 || editedItem.isClosed" >
        Delete
      </v-btn>
      </v-col>
    </v-row>
   <template>
  <div>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :headers='headersTable'
      :displayTopPagination="false"
      :canEdit="false"
      :canSave="true"
      :canMove="!editedItem.isClosed"
      :showSelect="true"
      :onlyDoubleClickEvent="true"
      :baseCrudKey="baseCrudKeyBelow"
      :dataMapper="dataMapper"
      :selectedItems="selectedItems"
      @onDoubleClicked="handleDoubleClick"
      @emitSelectedItem="emitSelectedItem"
      @loadCRUDList="handleLoadCRUDList"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='250'
    >
    </CRUDList>
  </div>
</template>
<v-dialog v-model="editFeesDialog" max-width="500"  max-height="500"
  class="input-text-size no-scroll-dialog">
  <v-card>
       <v-row>
        <v-col>
        <investmentDetails id="miscEditDialogMiscDetails"
            class="misc-edit-dialog-misc-details"
            :canAdd="true"
            :baseCrudKey="baseCrudKeyBelow"
            :responseInvestment="responseInvestment"
            @update:editFeesDialog="handleCloseDialog"
          />
        </v-col>
      </v-row>
    </v-card>
</v-dialog>
<miscInvestmentTransaction
      id="glUtilInterestApportionmentMiscTransactionBase"
      class="gl-util-interest-apportionment-misc-transaction-base"
      :openMiscEditedItemFlag="openMiscEditedItemFlag"
      :baseCrudKey="baseCrudKey"
      :investResult="editedItem"
      :selectedItems="this.selectedItems"
    />
  </div>
</template>

<script>
import {
  mapMutations, mapGetters, mapActions, mapState,
} from 'vuex';
import {
  mdiDelete,
} from '@mdi/js';
import investmentDetails from './investmentDetails.vue';
import GetMaxInvestmentNumber from './GetMaxInvestmentNumber.vue';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { toShortDate, toFiscalYear, toIsoDate } from '../../../util/shared/tmc-global';
import miscInvestmentTransaction from './miscInvestmentTransaction.vue';
import { amountToNumber, extractId } from '../../../util/shared/vue-global';
import isInterestLikeEntryType from './investmentEntryType.util';

const getHeadersTable = () => {
  const headers = [
    { text: 'Date', value: 'date' },
    { text: 'Original Principal', value: 'entryType', align: 'center' },
    {
      text: 'Amount', value: 'amount', formatter: 'amount', align: 'right',
    },
    {
      text: 'Receipted?', value: 'isReceipt', formatter: 'boolToStr', align: 'center',
    },
    { text: 'Description', value: 'description' },
  ];
  return headers;
};
const bankCrudKey = 'sharedBank';
const fundCrudKey = 'sharedFund';

export default {
  name: 'inverstmentEditTable',
  components: {
    CRUDList,
    ClarionDateControl,
    GetMaxInvestmentNumber,
    investmentDetails,
    miscInvestmentTransaction,
  },
  data: () => ({
    editFeesDialog: false,
    baseCrudKeyBelow: 'investmentBelow',
    baseCrudKeyDetails: 'investmentDetails',
    fundsFromStore: [],
    loadFundsList: [],
    fiscalYear: '',
    details: '',
    selectedItem: {},
    icons: {
      mdiDelete,
    },
    resultId: '',
    isMisReceipt: '',
    openMiscEditedItemFlag: 0,
    responseInvestment: {},
  }),
  props: {
    baseCrudKey: {
      type: String,
      default: 'investments',
    },
    isValidForm: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.fiscalYear = toFiscalYear(new Date(this.todaysDate));
    this.headersTable = getHeadersTable();
    this.loadBanks({
      criteria: {},
      baseCrudKey: bankCrudKey,
    });
    this.loadFundsAPI();
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', [
      'item',
      'index',
      'isVisible']),
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      investmentType: (state) => state.enums.GlInvestmentTypeEnum,
      nextInvestmentNumber: (state) => state.glDaily.glInvestmentTransaction.nextInvestmentNumber,
      storedSelectedItems: (state) => state.glDaily.glInvestmentTransaction.selectedItems,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    banks() {
      const bankObjs = this.items(bankCrudKey) || [];
      return [{ _id: null, bankName: '' }, ...bankObjs];
    },
    collateralBanks() {
      const bankObjs = this.items('GroupCodeDropdown') || [];
      return [{ bankIntials: null, bankName: '' }, ...bankObjs];
    },
    criteriaOfFY() {
      return (this.criteria(this.baseCrudKey).fiscalYear !== 0);
    },
    funds() {
      const fundList = this.criteriaOfFY ? this.loadFundsList : this.fundsFromStore;
      const updatedFundObj = fundList
        .filter((f) => f.type !== 'COLLECTIONFUND') // Filter out COLLECTIONFUND types
        .map((f) => ({
          ...f,
          fundDesc: f.fund === '0000' ? f.description : `${f.fund} - ${f.description || ''}`,
        }));
      return [{ _id: null, fund: '', fundDesc: '' }, ...updatedFundObj];
    },
    isCheckSelectedItem() {
      const slectedObj = this.selectedItems.filter((el) => typeof el === 'object');
      const allItemsHaveInterest = (slectedObj || []).length > 0 && (slectedObj || []).every((item) => isInterestLikeEntryType(item.entryType));
      return allItemsHaveInterest;
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        this.$emit('activeItem', this.editedItem);
        if (this.isNewItem) {
          this.determineReceiptNo();
        }
        if (this.criteriaOfFY) {
          // this.loadFundsAPI();
        } else {
          this.getFundsFromStore();
        }
        if (this.isNewItem) {
          this.setItems([this.baseCrudKeyBelow, []]);
        }
        if (this.editedItem.maturityDate === 'NONE') {
          this.setItem([this.baseCrudKey, { ...this.editedItem, maturityDate: '' }]);
        }
      } else {
        this.setinvestmentPolling(undefined);
      }
      return [];
    },
    bankGroupCodesUsingInitials() {
      const collateralBankObjs = this.items(this.collateralBankCrudKey) || [];
      const updatedObj = collateralBankObjs.map((c) => c.bankIntials).filter(Boolean);
      return updatedObj;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    fiscalYearLength() {
      return (this.fiscalYear || '').toString().length;
    },
    investmentTypeEnums() {
      if (!this.investmentType) {
        return [];
      }
      return this.investmentType;
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem', 'setItems', 'setIndex']),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions(['flashInfo']),
    ...mapActions('glDaily/glInvestmentTransaction', [
      'loadLastInvestmentNo',
      'deleteDetailsTrans',
      'upsertInvestmentTrans',
      'upsertInvestDetailsTransaction',
    ]),
    ...mapMutations('glDaily/glInvestmentTransaction', [
      'setinvestmentPolling',
      'setReceiptPulse',
      'setSelectedItems',
    ]),
    getFundsFromStore() {
      this.fundsFromStore = this.items(fundCrudKey) || [];
      return this.fundsFromStore;
    },
    checkAlphaNumeric(event) {
      if (!/[a-zA-Z0-9\s]/.test(event.key)) {
        this.ignoredValue = event.key ? event.key : '';
        event.preventDefault();
      }
    },
    async openDialog() {
      if (this.isNewItem) {
        this.$emit('upsertInvestment');
      }
      await new Promise((resolve) => setTimeout(resolve, 200));
      if (this.isValidForm) {
        this.setIndex([this.baseCrudKey, 0]);
      }
      if (!this.isNewItem) {
        this.editFeesDialog = true;
      }
    },

    async proceedToCreateMisc() {
      const selectedObj = this.selectedItems.find((el) => typeof el === 'object');
      if (selectedObj) {
        if (selectedObj.isMisReceipt) {
          if (window.confirm(`Misc Receipt is already created for this interest amount ${selectedObj.amount}`)) {
            this.openMiscEditedItemFlag += 1;
          } else {
            // Exit the function if not confirmed
          }
        } else {
          this.upsertTransaction();
          this.openMiscEditedItemFlag += 1;
        }
      }
    },

    checkBank() {
      if (this.editedItem.bank !== null) {
        this.editedItem.bank = null;
      }
      return this.editedItem.bank;
    },
    checkFund() {
      if (this.editedItem.fund !== null) {
        this.editedItem.fund = null;
      }
      return this.editedItem.fund;
    },
    async loadFundsAPI() {
      this.loadFundsList = await this.loadFunds({
        criteria: {
          fiscalYear: this.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      });
      return this.loadFundsList;
    },
    handleDoubleClick(item) {
      this.selectedItem = item;
      this.setItem([this.baseCrudKeyBelow, item]);
      this.editFeesDialog = true;
    },
    determineReceiptNo() {
      if (this.isNewItem) {
        if (this.fiscalYearLength !== 4) {
          this.setinvestmentPolling(undefined);
        } else {
          const inveTransPolling = setInterval(
            this.getRecNo,
            1200,
          );
          this.setinvestmentPolling(inveTransPolling);
        }
      }
    },
    getRecNo() {
      if (this.isNewItem) {
        this.determineNextReceiptNo();
      }
    },
    determineNextReceiptNo() {
      const loadReceiptNoPromise = this.loadLastInvestmentNo();
      loadReceiptNoPromise.then(() => {
        let animate = false;
        if (this.isNewItem) {
          animate = true;
        }
        this.editedItem.investmentId = this.nextInvestmentNumber;
        if (animate) {
          this.$nextTick(() => {
            this.setReceiptPulse(true);
          });
        } else {
          this.setReceiptPulse(false);
        }
      });
    },
    async handleLoadCRUDList() {
      try {
        const itemData = this.item(this.baseCrudKey);
        if (itemData && Array.isArray(itemData.details)) {
          const details = itemData.details.filter(Boolean);
          details.forEach((detailItem, i) => {
            // eslint-disable-next-line no-param-reassign
            detailItem.date = toShortDate(detailItem.date);
            // eslint-disable-next-line no-param-reassign
            detailItem.index = i;
          });
          this.setItems([this.baseCrudKeyBelow, details]);
        }
      } catch (error) {
        console.error('Error loading CRUD list:', error);
      }
    },
    async upsertTransaction() {
      try {
        const updatedItem = { ...this.item(this.baseCrudKey) } || {};
        const selectedItem = Array.isArray(this.selectedItems) && this.selectedItems.length > 0
          ? this.selectedItems[0]
          : {};
        const detailsResult = {};
        // Extract and set _id
        detailsResult._id = extractId(updatedItem._id);
        const detailIndex = selectedItem.index;
        detailsResult.index = typeof detailIndex === 'number' ? detailIndex : null;
        const detailsObject = {
          date: toIsoDate(selectedItem.date),
          isMisReceipt: this.isMisReceipt = true,
          amount: amountToNumber(selectedItem.amount),
          description: selectedItem.description,
          isReceipt: selectedItem.isReceipt = true,
          entryType: selectedItem.entryType,
        };
        detailsResult.details = detailsObject;
        delete updatedItem.interestAmount;
        delete updatedItem.principalAmount;
        delete updatedItem.daysBetweenDates;
        const response = await this.upsertInvestDetailsTransaction({
          item: detailsResult,
          baseCrudKey: this.baseCrudKey,
        });
        this.$nextTick(() => {
          this.setSelectedItems([]);
        });

        return response;
      } catch (error) {
        console.error('Error upserting transaction:', error);
        return null;
      }
    },
    emitSelectedItem(item) {
      this.selectedItems = item;
    },
    handleCloseDialog(value) {
      this.editFeesDialog = value;
    },
    dataMapper(dataItems) {
      if (dataItems == null) return [];
      return dataItems;
    },
    async deleteTransaction(item) {
      const { baseCrudKey, baseCrudKeyBelow } = this;
      await this.deleteDetailsTrans({ item, baseCrudKey, baseCrudKeyBelow }).then(() => {
        this.selectedItems = [];
      }).catch((e) => {
        console.warn(e);
        this.selectedItems = [];
      });
    },
    async deleteItems() {
      const slectedObj = this.selectedItems.filter((el) => typeof el === 'object');
      const selectedId = this.editedItem._id || this.resultId;
      if (window.confirm(`CAREFUL! Are you sure you want to DELETE ${slectedObj.length} record/s?`)) {
        for (let i = 0; i < (slectedObj || []).length; i += 1) {
          const item = slectedObj[i];
          item._id = selectedId;
          this.deleteTransaction(item);
        }
      }
    },
  },
};
</script>

<style scoped>
.heading{
  display: flex;
    justify-content: center;
    font-size: large;
    color: black;
    margin-bottom: 10px ;
}
.no-scroll-dialog .v-dialog__content {
  overflow: hidden;
}
</style>
